import { createSelector } from 'reselect';

const firmSelector = state => state.firm;
const all = state => state;

// FIRMS
export const firms = createSelector(firmSelector, state => state.firms);
export const firmForLookup = createSelector(firmSelector, state => state.firms);

export const firmOptions = createSelector(firms, firms =>
  firms?.map(firm => ({ value: firm.id, text: firm.name, key: firm.id }))
);

export const firmLookupOptions = createSelector(firmSelector, firms => {
  return firms?.firmsForLookup?.map(firm => ({ value: firm.id, text: firm.name, key: firm.id }));
});
export const allFirms = createSelector(firmForLookup, firms => firms?.firmForLookup);

export const allFirmsOptions = createSelector(firmSelector, ({ firmsForLookup }) =>
  firmsForLookup?.map(firm => ({ value: firm.id, text: firm.name, key: firm.id }))
);
export const firmsForUserCompany = createSelector(all, state => {
  const user = state.user.user;
  const GOW_USER_GROUP_ID = 'd99a0af7-a674-45f3-8a01-59c1457c355b';
  const isGowUser = state.user.userGroupId === GOW_USER_GROUP_ID;
  if (isGowUser) {
    return state.firm.firmsForLookup?.map(f => f.id);
  }
  return state.firm.firmsForLookup?.filter(firm => firm.userGroupId === user.userGroupId).map(f => f.id);
});

export const options = createSelector(firms, firms =>
  firms?.map(firm => ({ value: firm.id, text: firm.name, key: firm.id }))
);
export const current = createSelector(firmSelector, state => state.current);
